module.exports = __webpack_public_path__ + "static/media/avatar48.e5de32b1.png";